import { makeStyles } from "@material-ui/core";
export const useWarehouseSellerStyles = makeStyles((theme) => ({
    mainWrapper: {
        width: "100%",
        padding: theme.spacing(2),
    },
}));
